import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import HighchartsVue from 'highcharts-vue'
import * as Sentry from '@sentry/vue'
import { loadVee } from './vee'
import { vIntro, vIntroStep, vIntroPosition } from './directives/intro'
import 'intro.js/introjs.css'
import 'intro.js/themes/introjs-modern.css'

import { environment } from './services/environment'
import { setupInterceptors } from './services/api'

import i18n from './i18n'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetify)
app.use(i18n)
app.use(HighchartsVue)

app.directive('intro', vIntro)
app.directive('intro-step', vIntroStep)
app.directive('intro-position', vIntroPosition)

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    app,
    dsn: 'https://7271c17b0e64494c864736cf71ea2658@o268683.ingest.sentry.io/6034629',
    environment,
    integrations: [
      Sentry.browserTracingIntegration({ router })
    ],
    tracesSampleRate: environment === 'development' ? 1.0 : 0.05,
    ignoreErrors: [
      /^Request failed with status code 401$/,
      /Loading ([\w]+ )?chunk .+ failed/,
      /Network Error/,
      /^Cannot read properties of null \(reading 'style'\)$/,
      /^Cannot set properties of null \(setting 'className'\)$/,
      /^Cannot set property 'className' of null$/,
      /^Cannot read property 'style' of null$/,
      /^Navigation cancelled from .* to .* with a new navigation.$/,
      /^Avoided redundant navigation to current location.*$/,
      /^AbortError: Fetch is aborted$/
    ]
  })
  Sentry.setTag('application', 'vue-client')
}

setupInterceptors(router, store)

loadVee()

app.mount('#app')
